import { render } from "./MenuBarIconMenu.vue?vue&type=template&id=272f7cd2"
const script = {}

import exportComponent from "D:\\Code\\GitHub\\vue3-context-menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__